import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const MobileCleanerHeader = ({ user, setUser }) => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const initials = (() => {
    if (user?.name?.trim()) {
      return user.name.trim().split(/\s+/).slice(0, 2).map((p) => p[0]?.toUpperCase()).join("");
    }
    return user?.email?.[0]?.toUpperCase() || "?";
  })();

  const handleLogout = async () => {
    setOpen(false);
    await fetch("/auth/logout", { credentials: "include" });
    localStorage.removeItem("user");
    setUser(null);
    navigate("/");
  };

  return (
    <header className="h-12 shrink-0 bg-slate-900 text-slate-100 flex items-center border-b border-slate-800 z-50 relative">
      <div className="w-14 flex items-center justify-center shrink-0">
        <img src="/trace-mop-mark.png" alt="" className="h-8 w-auto" draggable={false} />
      </div>
      <div className="flex-1 text-center text-base font-bold tracking-tight pr-14">
        Trace Mop
      </div>
      <div className="absolute right-2 top-1/2 -translate-y-1/2">
        <button
          type="button"
          onClick={() => setOpen((p) => !p)}
          className="w-9 h-9 rounded-full overflow-hidden border-2 border-teal-500/60 bg-slate-800 flex items-center justify-center"
          aria-label="Profil"
        >
          {user?.photo_url ? (
            <img
              src={user.photo_url.startsWith("http") || user.photo_url.startsWith("/") ? user.photo_url : `/${user.photo_url}`}
              alt=""
              className="w-full h-full object-cover"
            />
          ) : (
            <span className="text-xs font-bold text-teal-300">{initials}</span>
          )}
        </button>
        {open && (
          <>
            <div className="fixed inset-0 z-40" onClick={() => setOpen(false)} />
            <div className="absolute right-0 top-full mt-1 w-48 bg-slate-800 border border-slate-700 rounded-lg shadow-xl z-50 py-1 text-sm">
              <div className="px-3 py-2 text-slate-400 text-xs truncate border-b border-slate-700">
                {user?.name || user?.email}
              </div>
              <button
                type="button"
                onClick={handleLogout}
                className="w-full text-left px-3 py-2 text-slate-100 hover:bg-slate-700"
              >
                Kijelentkezes
              </button>
            </div>
          </>
        )}
      </div>
    </header>
  );
};

export default MobileCleanerHeader;
